import { useCallback, useEffect, useState } from "react";
import { api, API_BASE } from "../../../lib/api";

export const MODELS = ["gpt-luna", "gpt-astra", "gpt-terra", "gpt-5-5", "claude-sonnet", "gemini-pro"];
export const VOICE_MODELS = ["gpt-realtime-2.1-mini", "gpt-realtime-2.1", "gpt-realtime-2.0", "gpt-live-1"];
export const VOICES = ["marin", "cedar", "alloy", "ash", "ballad", "coral", "echo", "sage", "shimmer", "verse"];
export const PROV = { runway: "Runway Characters", liveavatar: "LiveAvatar" };
export const VIDEO_STATUS = {
  ready: ["Video siap", "bg-emerald-50 text-emerald-700"],
  no_avatar: ["Avatar belum dipilih", "bg-amber-50 text-amber-700"],
  paused: ["Video dijeda", "bg-amber-50 text-amber-700"],
  disabled: ["Video nonaktif", "bg-slate-100 text-slate-500"],
  provider_not_configured: ["Provider belum diatur", "bg-rose-50 text-rose-700"],
};
export const FIELDS = ["enabled", "name", "role_key", "role_label", "summary", "portrait", "model", "voice_model", "voice", "system_prompt", "knowledge", "video_enabled", "avatar"];
export const toBody = (a) => Object.fromEntries(FIELDS.map((k) => [k, a[k] ?? (k === "role_label" ? null : k === "avatar" ? {} : a[k])]));

export const blankAgent = (role) => ({
  enabled: false, name: "", role_key: role?.key || "general", role_label: null, summary: "", portrait: "",
  model: MODELS[0], voice_model: VOICE_MODELS[0], voice: VOICES[0], system_prompt: role?.preset_prompt || "", knowledge: "",
  video_enabled: false, avatar: { runway: {}, liveavatar: { sandbox: false } },
});

export function useRoles() {
  const [roles, setRoles] = useState(null);
  const load = useCallback(() => api.get("/platform/support-roles").then((r) => setRoles(Array.isArray(r.data) ? r.data : r.data.items || [])).catch(() => setRoles([])), []);
  useEffect(() => { load(); }, [load]);
  return [roles, load];
}

export const isSafeImg = (u) => /^https?:\/\//i.test(u || "") || /^\/[^/]/.test(u || "");
// Relative portraits (e.g. /brand/x.jpg) live on the main app origin.
export const imgSrc = (u) => (/^\/[^/]/.test(u || "") ? `${API_BASE.replace(/\/api$/, "")}${u}` : u);
